import PlayerAnimation from "core/player-animation";
const ANIM_SPRITES = ["player_walk01", "player_walk02", "player_walk03", "player_walk04", "player_walk05", "player_walk06", "player_walk07", "player_walk08", "player_walk09", "player_walk10", "player_walk11"];
export default function PlayerAnim(element) {
  const container = element.querySelector("#player_animation");
  container.appendChild(PlayerAnimation("player1", ANIM_SPRITES, 6));
  container.appendChild(PlayerAnimation("player2", ANIM_SPRITES, 3));
  container.appendChild(PlayerAnimation("player3", ANIM_SPRITES, 0));
}